export const isPrivateRoute = (path: string) => {
  if (path.match(/admin|collector/)) {
    return true;
  } else {
    return false;
  }
};